module.exports = __webpack_public_path__ + "img/yieldnest.a9cc40bd.svg";